import script from "./ProcedureTableToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureTableToolbar.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureTableToolbar.vue?vue&type=style&index=0&id=87944efe&lang=scss"

const __exports__ = script;

export default __exports__
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QBtn});
